import React from 'react';

const AccountIcon: React.FC = () => (
  <svg
    clipRule="evenodd"
    fill="currentColor"
    fillRule="evenodd"
    height="1em"
    viewBox="0 0 23 15"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 9.00003C7.70914 9.00003 9.5 7.20917 9.5 5.00003C9.5 2.79089 7.70914 1.00003 5.5 1.00003C3.29086 1.00003 1.5 2.79089 1.5 5.00003C1.5 7.20917 3.29086 9.00003 5.5 9.00003ZM5.5 10C8.26142 10 10.5 7.76145 10.5 5.00003C10.5 2.23861 8.26142 3.05176e-05 5.5 3.05176e-05C2.73858 3.05176e-05 0.5 2.23861 0.5 5.00003C0.5 7.76145 2.73858 10 5.5 10ZM3.5 12.5C2.11929 12.5 1 13.6193 1 15H0C0 13.067 1.567 11.5 3.5 11.5H7.5C9.433 11.5 11 13.067 11 15H10C10 13.6193 8.88071 12.5 7.5 12.5H3.5ZM14 1.50003H22.5V0.500031H14V1.50003ZM22.5 5.50003H14V4.50003H22.5V5.50003ZM14 9.50003H22.5V8.50003H14V9.50003Z" />
  </svg>
);

export { AccountIcon };
